var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormHelperText, Switch } from "@mui/material";
import clsx from "clsx";
import { useMemo } from "react";
import { UiFormControlLabel } from "../ui_form_control_label";
import { UiTooltip } from "../ui_tooltip";
import { useStyles } from "./ui_switch.css";
export const UiSwitch = (_a) => {
    var { color, errorMessage, gutterBottom, label, disableTooltipTitle, subLabel, classes: extraClasses } = _a, props = __rest(_a, ["color", "errorMessage", "gutterBottom", "label", "disableTooltipTitle", "subLabel", "classes"]);
    const classes = useStyles({ color, gutterBottom });
    const Component = useMemo(() => (_jsxs(Box, { className: classes.ui_switch, children: [_jsx(UiFormControlLabel, { classes: { label: clsx(classes.switch_label, extraClasses === null || extraClasses === void 0 ? void 0 : extraClasses.label) }, control: _jsx(Switch, Object.assign({ classes: Object.assign({ switchBase: classes["ui_switch__switch_base--checked"] }, extraClasses), checked: props.checked }, props)), label: label, subLabel: subLabel }), errorMessage && _jsx(FormHelperText, { children: errorMessage })] })), [classes, errorMessage, extraClasses, label, props, subLabel]);
    return disableTooltipTitle && props.disabled ? (_jsx(UiTooltip, { title: disableTooltipTitle, children: Component })) : (Component);
};
//# sourceMappingURL=ui_switch.js.map